const COLORS: IColorsInterface = {
  brandWhite: "#FFFFFF",
  brandYellow50: "#EEAA00",

  brandBlue50: "#72a0ff",
  brandBlue40: "#90B5FC",
  brandBlue30: "#acc7fe",
  brandBlue20: "#c8dafe",
  brandBlue10: "#e3ebfe",

  brandGreen10: "#e6f5d6",
  brandGreen20: "#cceaaa",
  brandGreen30: "#b3e081",
  brandGreen40: "#9bd75b",
  brandGreen50: "#7FCF26",

  brandOrange10: "#fae1cd",
  brandOrange20: "#f7c39e",
  brandOrange30: "#f0a56e",
  brandOrange40: "#ee8742",
  brandOrange50: "#eb6905",

  brandGray10: "#ebebeb",
  brandGray20: "#b1b3b3",
  brandGray30: "#888b8d",
  brandGray40: "#5a5a5a",
  brandGray50: "#262626",

  dsBlack: "#000000",
  dsBluePrimary: "#3E5B83",
  dsGrayAccent: "#E0E0E0",
  dsGrayBG: "#EDEDED",
  dsGrayText: "#232322",
  dsGreenMedium: "#608F55",
  dsRed: "#C8321E",

  uiDark: "#262626",
  uiExtraDark: "#1B1B1A",
  uiLight: "#fff",
  uiPrimary: "#72a0ff",
  uiCTA: "#72a0ff",

  bgLight: "#fafafa",
  bgMed: "#f4f4f4",
  bgDark: "#EBEBEB",

  primaryText: "#262626",
  secondaryText: "#828282",

  warning: "#DD8D3B",
  success: "#16A34A",

  // Lightspeed colors
  lspdGray50: "#F2F5F8",
  lspdGray800: "#2F3137",
  lspdBlue500: "#2E61DE",
  lspdMaple500: "#DE2E37",

  surchargingNoticeBackground: "#EEF2FD",
  surchargingNoticeBorder: "#D5E0FB",
  surchargingNoticeIcon: "#3B60D6",
  surchargingNoticeText: "#2B3A67",
  surchargingNoticeTextStrong: "#1F2D55",
  surchargingResponsibilityBackgroundStart: "#F7F9FC",
  surchargingResponsibilityBackgroundEnd: "#EEF2F8",
  surchargingResponsibilityBorder: "#E6EBF2",
  surchargingResponsibilityText: "#475467",
  surchargingResponsibilityTextSecondary: "#667085",
  surchargingResponsibilityLegalText: "#98A2B3",
  surchargingServiceFeeWarningBorder: "#F2D9B6",
  surchargingServiceFeeWarningIcon: "#DD8D3B",
  surchargingServiceFeeWarningText: "#7A5A25",
  surchargingServiceFeeWarningTextStrong: "#5F4415",
  surchargingServiceFeeWarningLink: "#8A5A12",

  // Button colors
  lspdPrimaryGradient: "linear-gradient(180deg, #537DEC 0%, #2E61DE 100%)",
  lspdPrimaryBorder: "#1844CC",
  lspdSecondaryGradient: "linear-gradient(180deg, #FFF 0%, #F5F7FF 100%)",
  lspdSecondaryBorder: "#BCC4CA",
};

export interface IColorsInterface {
  brandWhite: string;
  brandYellow50: string;

  brandBlue50: string;
  brandBlue40: string;
  brandBlue30: string;
  brandBlue20: string;
  brandBlue10: string;

  brandGreen10: string;
  brandGreen20: string;
  brandGreen30: string;
  brandGreen40: string;
  brandGreen50: string;

  brandOrange10: string;
  brandOrange20: string;
  brandOrange30: string;
  brandOrange40: string;
  brandOrange50: string;

  brandGray10: string;
  brandGray20: string;
  brandGray30: string;
  brandGray40: string;
  brandGray50: string;

  dsBlack: string;
  dsBluePrimary: string;
  dsGrayAccent: string;
  dsGrayBG: string;
  dsGrayText: string;
  dsGreenMedium: string;
  dsRed: string;

  uiDark: string;
  uiLight: string;
  uiPrimary: string;
  uiCTA: string;

  uiExtraDark: string;
  bgLight: string;
  bgMed: string;
  bgDark: string;

  primaryText: string;
  secondaryText: string;

  warning: string;
  success: string;

  // Lightspeed colors
  lspdGray50: string;
  lspdGray800: string;
  lspdBlue500: string;
  lspdMaple500: string;
  surchargingNoticeBackground: string;
  surchargingNoticeBorder: string;
  surchargingNoticeIcon: string;
  surchargingNoticeText: string;
  surchargingNoticeTextStrong: string;
  surchargingResponsibilityBackgroundStart: string;
  surchargingResponsibilityBackgroundEnd: string;
  surchargingResponsibilityBorder: string;
  surchargingResponsibilityText: string;
  surchargingResponsibilityTextSecondary: string;
  surchargingResponsibilityLegalText: string;
  surchargingServiceFeeWarningBorder: string;
  surchargingServiceFeeWarningIcon: string;
  surchargingServiceFeeWarningText: string;
  surchargingServiceFeeWarningTextStrong: string;
  surchargingServiceFeeWarningLink: string;
  lspdPrimaryGradient: string;
  lspdPrimaryBorder: string;
  lspdSecondaryGradient: string;
  lspdSecondaryBorder: string;
}

export default COLORS;
